import { Loader2 } from "lucide-react";

const LoadingScreen = () => {
  return (
    <div className="min-h-screen h-screen w-full flex items-center justify-center bg-transparent">
      <div className="w-[400px] max-w-full bg-white/5 backdrop-blur-sm rounded-xl px-6 py-4 shadow-[0_4px_20px_rgba(0,0,0,0.1)] border border-white/20">
        <div className="flex flex-col items-center justify-center gap-3">
          <Loader2 className="h-5 w-5 animate-spin text-gray-600" />
          <p className="text-sm text-gray-600">Loading your audio player...</p>
        </div>
      </div>
    </div>
  );
};

export default LoadingScreen;
